import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import StatisticsLoader from '../../core/StatisticsLoader';
import { globalStyles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import { LANGS } from '../../core/utils/constants';
import AccessibleTooltip from '../../core/AccessibleTooltip';

const styles = () => {
    return Object.assign({
        tableCell: {
            overflow: 'hidden'
        }
    }, globalStyles);
};

const countTypeMapping = {
    PREFLABEL: { "en": "Preferred Labels" },
    ALTLABEL: { "en": "Alternative Labels" }
};

class SchemeStatistics extends React.Component {

    displayView = (data) => {

        const classes = this.props.classes;
        const conceptsLoaded = data.some(stat => stat.viewCountType === "CONCEPTCOUNT");
        const labelsLoaded = data.some(stat => stat.viewCountType === "XLLABELCOUNT");

        return <ProjectConsumer>
            {({ defaultLang }) => (
                <div style={{ margin: '-2px' }}>
                    <Grid container spacing={2} classes={
                        {
                            "spacing-xs-2": this.props.classes.fullGrid
                        }
                    }>
                        <Grid item xs={12} md={4}>
                            <TitledPanel height="full" fontSize="large" title="Basic Statistics">
                                {conceptsLoaded &&
                                    <div>
                                        <Typography className={classes.subSubHeading}>Concepts</Typography>
                                        <Typography data-test="concept-count" className={classes.statistic}>{data.find(stat => stat.viewCountType === "CONCEPTCOUNT").viewCount}</Typography>
                                        <Typography className={classes.subSubHeading}>Top Concepts</Typography>
                                        <Typography data-test="top-concept-count" className={classes.statistic}>{data.find(stat => stat.viewCountType === "TOPCONCEPTCOUNT").viewCount}</Typography>
                                    </div>
                                }
                                {labelsLoaded &&
                                    <div>
                                        <Typography className={classes.subSubHeading}>XL Labels</Typography>
                                        <Typography data-test="xllabel-count" className={classes.statistic}>{data.find(stat => stat.viewCountType === "XLLABELCOUNT").viewCount}</Typography>
                                    </div>
                                }
                            </TitledPanel>
                        </Grid>
                        {Object.keys(countTypeMapping).map((countType, c) =>
                            <Grid item xs={12} md={4} key={"stat-" + c}>
                                <TitledPanel height="full" fontSize="large" title={countTypeMapping[countType].en}>
                                    {data.some(stat => stat.type === "LabelCount" && stat.viewCountType === countType) &&
                                        <Table data-test={countTypeMapping[countType].en}>
                                            <TableHead>
                                                <TableRow data-test="headers">
                                                    <TableCell component="th" className={classes.tableHeading} style={{ paddingLeft: '0px' }}>Language<br />Code</TableCell>
                                                    <TableCell component="th" className={classes.tableHeading} style={{ verticalAlign: 'bottom' }}>Language</TableCell>
                                                    <TableCell component="th" style={{ textAlign: 'right', verticalAlign: 'bottom' }} className={classes.tableHeading}>Count</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    data.filter(stat => stat.type === "LabelCount" && stat.viewCountType === countType)
                                                        .sort((a, b) => a.viewLanguage < b.viewLanguage ? -1 : 1)
                                                        .map((stat, i) =>
                                                            <TableRow key={"stat-" + i}>
                                                                <TableCell
                                                                    className={classes.tableCell}
                                                                    style={{ paddingLeft: '0px' }}>
                                                                    <AccessibleTooltip title={stat.viewLanguage} placement="right-end">
                                                                        <Avatar
                                                                            style={stat.viewLanguage.length < 3 ?
                                                                                { height: '40px', width: '40px', fontSize: '16px' }
                                                                                :
                                                                                stat.viewLanguage.length < 6 ?
                                                                                    {
                                                                                        height: '40px',
                                                                                        width: '40px',
                                                                                        fontSize: '14px'
                                                                                    }
                                                                                    :
                                                                                    {
                                                                                        height: '40px',
                                                                                        width: '80px',
                                                                                        whiteSpace: 'nowrap',
                                                                                        fontSize: '14px',
                                                                                        borderRadius: '40px'
                                                                                    }
                                                                            }
                                                                            className={classes.fieldAvatar}>{stat.viewLanguage}</Avatar>
                                                                    </AccessibleTooltip>
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell} style={{ verticalAlign: 'middle' }}>{
                                                                    LANGS[stat.viewLanguage] ?
                                                                        LANGS[stat.viewLanguage][defaultLang]
                                                                        :
                                                                        stat.viewLanguage === "" ?
                                                                            "No Language"
                                                                            :
                                                                            ''
                                                                }
                                                                </TableCell>
                                                                <TableCell data-test="view-count" align="right" className={classes.statistic}>
                                                                    {stat.viewCount}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                }
                                            </TableBody>
                                        </Table>
                                    }
                                </TitledPanel>
                            </Grid>
                        )}
                        {this.props.workflow &&
                            <Grid item xs={12} md={4}>
                                <TitledPanel dataTest="workflow-stats" fontSize="large" title="Workflow Statistics">
                                    <Typography paragraph variant="caption">Deprecated resources are not included.</Typography>
                                    {data.some(stat => stat.viewCountType === "UNCATEGORISEDCONCEPTCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Uncategorised Concepts</Typography>
                                            <Typography data-test="uncategorised-concept-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "UNCATEGORISEDCONCEPTCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "DRAFTCONCEPTCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Draft Concepts</Typography>
                                            <Typography data-test="draft-concept-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "DRAFTCONCEPTCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "APPROVEDCONCEPTCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Approved Concepts</Typography>
                                            <Typography data-test="approved-concept-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "APPROVEDCONCEPTCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "REJECTEDCONCEPTCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Rejected Concepts</Typography>
                                            <Typography data-test="rejected-concept-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "REJECTEDCONCEPTCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "UNCATEGORISEDLABELCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Uncategorised XL Labels</Typography>
                                            <Typography data-test="uncategorised-xllabel-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "UNCATEGORISEDLABELCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "DRAFTLABELCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Draft XL Labels</Typography>
                                            <Typography data-test="draft-xllabel-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "DRAFTLABELCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "APPROVEDLABELCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Approved XL Labels</Typography>
                                            <Typography data-test="approved-xllabel-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "APPROVEDLABELCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                    {data.some(stat => stat.viewCountType === "REJECTEDLABELCOUNT") &&
                                        <div>
                                            <Typography className={classes.subSubHeading}>Rejected XL Labels</Typography>
                                            <Typography data-test="rejected-xllabel-count" className={classes.statistic}>
                                                {data.find(stat => stat.viewCountType === "REJECTEDLABELCOUNT").viewCount}
                                            </Typography>
                                        </div>
                                    }
                                </TitledPanel>
                            </Grid>
                        }
                    </Grid>
                </div>
            )}
        </ProjectConsumer>;
    };

    render() {

        let exportNames = [
            "taxonomyconceptstatistics",
            "taxonomylabelstatistics",
            "taxonomypreflabelstatistics",
            "taxonomyaltlabelstatistics"
        ];
        if (this.props.workflow) exportNames = exportNames.concat([
            "taxonomyworkflowuncategorisedconceptsstatistics",
            "taxonomyworkflowuncategorisedlabelsstatistics",
            "taxonomyworkflowdraftconceptsstatistics",
            "taxonomyworkflowdraftlabelsstatistics",
            "taxonomyworkflowapprovedconceptsstatistics",
            "taxonomyworkflowapprovedlabelsstatistics",
            "taxonomyworkflowrejectedstatistics"
        ]);

        return (
            <StatisticsLoader
                workflow={false}
                component={this.props.id}
                graph={this.props.graph}
                displayView={this.displayView}
                exportNames={exportNames}>
            </StatisticsLoader>
        );
    }

}

SchemeStatistics.defaultProps = {
    workflow: false
};

SchemeStatistics.propTypes = {
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    workflow: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(SchemeStatistics);